import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-repbusinessreport',
  templateUrl: './repbusinessreport.component.html',
  styleUrls:['./repbusinessreport.component.scss'],
})


export class RepbusinessreportComponent implements OnInit {
  offrepwiseData;
  today = new Date();
  startDate = '';
  endDate = '';
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  off_rep_name;
  appliedFilters: any = {}; 

  constructor(
    public dialogref: MatDialogRef<RepbusinessreportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.offrepwiseData = this.data['offrepwisedata'];
    this.off_rep_name = this.data['off_rep_name'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(this.offrepwiseData);
    
    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 4 + 8;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 4;

    // this.getoffdata();
    this.setData();
  }

   countryNameNew: any
  stateNameNew: any
  
  //OLD Correct Code 
//   setData() {
//     let finalTotal = {};

//     this.subTypesName.forEach((b: any, i) => {
//         if (b.isVisible) {
//             let name = this.getKey(b.name);
//             finalTotal[name + '_एकूण'] = 0;
//             finalTotal[name + '_नवीन'] = 0;
//             finalTotal[name + '_नूतनीकरण'] = 0;
//             finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//             if (i === 0) {
//                 finalTotal['name'] = 'एकूण';
//                 finalTotal['sub'] = 0;
//                 finalTotal['एकूण'] = 0;
//                 finalTotal['नवीन'] = 0;
//                 finalTotal['नूतनीकरण'] = 0;
//                 finalTotal['नूतनीकरणबाकी'] = 0;
//             }
//         }
//     });

//     let uniqueRepwiseData = this.uniqueData(this.offrepwiseData, (a) => a.rep_name);

//     uniqueRepwiseData.forEach((repDataItem: any) => {
//         let repwiseData = this.offrepwiseData.filter((a) => a.rep_name === repDataItem.rep_name);
//         let totalData = {};

//         this.subTypesName.forEach((b: any, i) => {
//             if (b.isVisible) {
//                 let name = this.getKey(b.name);
//                 totalData[name + '_एकूण'] = 0;
//                 totalData[name + '_नवीन'] = 0;
//                 totalData[name + '_नूतनीकरण'] = 0;
//                 totalData[name + '_नूतनीकरणबाकी'] = 0;
//                 if (i === 0) {
//                     totalData['sub'] = 0;
//                     totalData['एकूण'] = 0;
//                     totalData['नवीन'] = 0;
//                     totalData['नूतनीकरण'] = 0;
//                     totalData['नूतनीकरणबाकी'] = 0;
//                 }
//             }
//         });

//         repwiseData.forEach((a: any, i) => {
//             if (i === 0) {
//                 totalData['rep_name'] = a.rep_name;
//                 totalData['office_rep_name'] = a.office_rep_name;
//                 totalData['rep_taluka'] = a.rep_taluka;
//             }

//             let name = this.getKey(a.subscription_type);
//             let today = new Date();
//             today.setMonth(today.getMonth() + 1);

//             if (a['sub_perid_to_date'] > formatDate(new Date(today), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')) {
//                 totalData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//                 finalTotal[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//                 totalData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//                 finalTotal[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//                 totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//                 finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//                 totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//                 finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//                 totalData['sub'] += 1;
//                 finalTotal['sub'] += 1;

//                 totalData[name + '_एकूण'] += parseInt(a.total_amt);
//                 finalTotal[name + '_एकूण'] += parseInt(a.total_amt);

//                 totalData['एकूण'] += parseInt(a.total_amt);
//                 finalTotal['एकूण'] += parseInt(a.total_amt);
//             } else {
//                 totalData[name + '_नूतनीकरणबाकी'] += 1;
//                 finalTotal[name + '_नूतनीकरणबाकी'] += 1;

//                 totalData['नूतनीकरणबाकी'] += 1;
//                 finalTotal['नूतनीकरणबाकी'] += 1;
//             }
//         });

//         this.finalData.push(totalData);
//     });

//     this.finalData.push(finalTotal);
//     console.log(this.finalData);

//     this.isLoading = false;
// }

//Old Correct Code नूतनीकरणबाकी Column Show 
// setData() {
//   let finalTotal: any = {
//     name: 'एकूण',
//     sub: 0,
//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0
//   };

//   this.subTypesName.forEach((b: any) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);
//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;
//     }
//   });

//   let uniqueRepwiseData = this.uniqueData(this.offrepwiseData, (a) => a.rep_name);

//   uniqueRepwiseData.forEach((repDataItem: any) => {
//     let repwiseData = this.offrepwiseData.filter((a) => a.rep_name === repDataItem.rep_name);

//     let totalData: any = {
//       sub: 0,
//       'एकूण': 0,
//       'नवीन': 0,
//       'नूतनीकरण': 0,
//       'नूतनीकरणबाकी': 0
//     };

//     this.subTypesName.forEach((b: any) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         totalData[name + '_एकूण'] = 0;
//         totalData[name + '_नवीन'] = 0;
//         totalData[name + '_नूतनीकरण'] = 0;
//         totalData[name + '_नूतनीकरणबाकी'] = 0;
//       }
//     });

//     repwiseData.forEach((a: any, i) => {
//       if (i === 0) {
//         totalData['rep_name'] = a.rep_name;
//         totalData['office_rep_name'] = a.office_rep_name;
//         totalData['rep_taluka'] = a.rep_taluka;
//       }

//       let name = this.getKey(a.subscription_type);
//       let today = new Date();
//       today.setMonth(today.getMonth() + 1);

//       if (a['sub_perid_to_date'] > formatDate(new Date(today), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')) {
//         // नवीन
//         totalData[name + '_नवीन'] = (totalData[name + '_नवीन'] || 0) + (a.rcpt_type === 'New' ? 1 : 0);
//         finalTotal[name + '_नवीन'] = (finalTotal[name + '_नवीन'] || 0) + (a.rcpt_type === 'New' ? 1 : 0);

//         // नूतनीकरण
//         totalData[name + '_नूतनीकरण'] = (totalData[name + '_नूतनीकरण'] || 0) + (a.rcpt_type === 'Renew' ? 1 : 0);
//         finalTotal[name + '_नूतनीकरण'] = (finalTotal[name + '_नूतनीकरण'] || 0) + (a.rcpt_type === 'Renew' ? 1 : 0);

//         totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
//         finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;

//         totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
//         finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

//         totalData['sub'] += 1;
//         finalTotal['sub'] += 1;

//         totalData[name + '_एकूण'] = (totalData[name + '_एकूण'] || 0) + parseInt(a.total_amt);
//         finalTotal[name + '_एकूण'] = (finalTotal[name + '_एकूण'] || 0) + parseInt(a.total_amt);

//         totalData['एकूण'] += parseInt(a.total_amt);
//         finalTotal['एकूण'] += parseInt(a.total_amt);
//       } else {
//         totalData[name + '_नूतनीकरणबाकी'] = (totalData[name + '_नूतनीकरणबाकी'] || 0) + 1;
//         finalTotal[name + '_नूतनीकरणबाकी'] = (finalTotal[name + '_नूतनीकरणबाकी'] || 0) + 1;

//         totalData['नूतनीकरणबाकी'] += 1;
//         finalTotal['नूतनीकरणबाकी'] += 1;
//       }
//     });

//     this.finalData.push(totalData);
//   });

//   this.finalData.push(finalTotal);
//   console.log(this.finalData);

//   this.isLoading = false;
// }


// setData() {

//   let finalTotal: any = {
//     name: 'एकूण',
//     sub: 0,
//     'एकूण': 0,
//     'नवीन': 0,
//     'नूतनीकरण': 0,
//     'नूतनीकरणबाकी': 0
//   };

//   // Dynamic fields initialize
//   this.subTypesName.forEach((b: any) => {
//     if (b.isVisible) {
//       let name = this.getKey(b.name);

//       finalTotal[`${name}_एकूण`] = 0;
//       finalTotal[`${name}_नवीन`] = 0;
//       finalTotal[`${name}_नूतनीकरण`] = 0;
//       finalTotal[`${name}_नूतनीकरणबाकी`] = 0;
//     }
//   });

//   let uniqueRepwiseData = this.uniqueData(this.offrepwiseData, (a) => a.rep_name);

//   uniqueRepwiseData.forEach((repDataItem: any) => {

//     let repwiseData = this.offrepwiseData.filter(
//       (a) => a.rep_name === repDataItem.rep_name
//     );

//     let totalData: any = {
//       sub: 0,
//       'एकूण': 0,
//       'नवीन': 0,
//       'नूतनीकरण': 0,
//       'नूतनीकरणबाकी': 0
//     };

//     // Dynamic fields initialize
//     this.subTypesName.forEach((b: any) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);

//         totalData[`${name}_एकूण`] = 0;
//         totalData[`${name}_नवीन`] = 0;
//         totalData[`${name}_नूतनीकरण`] = 0;
//         totalData[`${name}_नूतनीकरणबाकी`] = 0;
//       }
//     });

//     repwiseData.forEach((a: any, i) => {

//       if (i === 0) {
//         totalData['rep_name'] = a.rep_name;
//         totalData['office_rep_name'] = a.office_rep_name;
//         totalData['rep_taluka'] = a.rep_taluka;
//       }

//       let name = this.getKey(a.subscription_type);

//       let today = new Date();
//       today.setMonth(today.getMonth() + 1);

//       let isActive =
//         a['sub_perid_to_date'] >
//         formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

//       let amount = Number(a.total_amt) || 0;

//       if (isActive) {

//         if (a.rcpt_type === 'New') {
//           totalData[`${name}_नवीन`] += 1;
//           finalTotal[`${name}_नवीन`] += 1;

//           totalData['नवीन'] += 1;
//           finalTotal['नवीन'] += 1;
//         }

//         if (a.rcpt_type === 'Renew') {
//           totalData[`${name}_नूतनीकरण`] += 1;
//           finalTotal[`${name}_नूतनीकरण`] += 1;

//           totalData['नूतनीकरण'] += 1;
//           finalTotal['नूतनीकरण'] += 1;
//         }

//         // Amount
//         totalData[`${name}_एकूण`] += amount;
//         finalTotal[`${name}_एकूण`] += amount;

//         totalData['एकूण'] += amount;
//         finalTotal['एकूण'] += amount;

//       } else {

//         // Renewal Pending
//         totalData[`${name}_नूतनीकरणबाकी`] += 1;
//         finalTotal[`${name}_नूतनीकरणबाकी`] += 1;

//         totalData['नूतनीकरणबाकी'] += 1;
//         finalTotal['नूतनीकरणबाकी'] += 1;
//       }

//       // ✅ FIX — Subscriber count should include ALL
//       totalData['sub'] =
//         totalData['नवीन'] +
//         totalData['नूतनीकरण'] +
//         totalData['नूतनीकरणबाकी'];

//       finalTotal['sub'] =
//         finalTotal['नवीन'] +
//         finalTotal['नूतनीकरण'] +
//         finalTotal['नूतनीकरणबाकी'];
//     });

//     this.finalData.push(totalData);
//   });

//   this.finalData.push(finalTotal);

//   console.log(this.finalData);

//   this.isLoading = false;
// }


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

setData() {

  let finalTotal: any = {
    name: 'एकूण',
    sub: 0,
    'एकूण': 0,
    'नवीन': 0,
    'नूतनीकरण': 0,
    'नूतनीकरणबाकी': 0
  };

  // Dynamic fields initialize
  this.subTypesName.forEach((b: any) => {

    if (b.isVisible) {

      let name = this.getKey(b.name);

      finalTotal[`${name}_एकूण`] = 0;
      finalTotal[`${name}_नवीन`] = 0;
      finalTotal[`${name}_नूतनीकरण`] = 0;
      finalTotal[`${name}_नूतनीकरणबाकी`] = 0;
    }
  });

  this.finalData = [];

  let uniqueRepwiseData = this.uniqueData(
    this.offrepwiseData,
    (a: any) => a.rep_name
  );

  uniqueRepwiseData.forEach((repDataItem: any) => {

    let repwiseData = this.offrepwiseData.filter(
      (a: any) => a.rep_name === repDataItem.rep_name
    );

    let totalData: any = {
      sub: 0,
      'एकूण': 0,
      'नवीन': 0,
      'नूतनीकरण': 0,
      'नूतनीकरणबाकी': 0
    };

    // Dynamic fields initialize
    this.subTypesName.forEach((b: any) => {

      if (b.isVisible) {

        let name = this.getKey(b.name);

        totalData[`${name}_एकूण`] = 0;
        totalData[`${name}_नवीन`] = 0;
        totalData[`${name}_नूतनीकरण`] = 0;
        totalData[`${name}_नूतनीकरणबाकी`] = 0;
      }
    });

    repwiseData.forEach((a: any, i: number) => {

      if (i === 0) {

        totalData['rep_name'] = a.rep_name;
        totalData['office_rep_name'] = a.office_rep_name;
        totalData['rep_taluka'] = a.rep_taluka;
      }

      let name = this.getKey(a.subscription_type);

      let today = new Date();
      today.setMonth(today.getMonth() + 1);

      let isActive =
        a['sub_perid_to_date'] >
        formatDate(today, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');

      // ✅ FIXED AMOUNT
      // Earlier total_amt was taking wrong/partial value
      let amount =
        Number(a.net_amount || a.amount || a.total_amt || 0);

      // ✅ ALWAYS ADD TOTAL AMOUNT
      totalData['एकूण'] += amount;
      finalTotal['एकूण'] += amount;

      // ✅ SUBTYPE AMOUNT
      if (name) {

        totalData[`${name}_एकूण`] += amount;
        finalTotal[`${name}_एकूण`] += amount;
      }

      if (isActive) {

        if (a.rcpt_type === 'New') {

          if (name) {
            totalData[`${name}_नवीन`] += 1;
            finalTotal[`${name}_नवीन`] += 1;
          }

          totalData['नवीन'] += 1;
          finalTotal['नवीन'] += 1;
        }

        if (a.rcpt_type === 'Renew') {

          if (name) {
            totalData[`${name}_नूतनीकरण`] += 1;
            finalTotal[`${name}_नूतनीकरण`] += 1;
          }

          totalData['नूतनीकरण'] += 1;
          finalTotal['नूतनीकरण'] += 1;
        }

      } else {

        // Renewal Pending
        if (name) {

          totalData[`${name}_नूतनीकरणबाकी`] += 1;
          finalTotal[`${name}_नूतनीकरणबाकी`] += 1;
        }

        totalData['नूतनीकरणबाकी'] += 1;
        finalTotal['नूतनीकरणबाकी'] += 1;
      }

      // Subscriber count
      totalData['sub'] =
        Number(totalData['नवीन'] || 0) +
        Number(totalData['नूतनीकरण'] || 0) +
        Number(totalData['नूतनीकरणबाकी'] || 0);

      finalTotal['sub'] =
        Number(finalTotal['नवीन'] || 0) +
        Number(finalTotal['नूतनीकरण'] || 0) +
        Number(finalTotal['नूतनीकरणबाकी'] || 0);
    });

    this.finalData.push(totalData);
  });

  this.finalData.push(finalTotal);

  console.log(this.finalData);

  this.isLoading = false;
}

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


   //Main Report Method Use in all Printing Page
  show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                 height: auto !important;
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                                  table-layout: auto !important; 
                             }
                             th, td { 
                                 padding: 2px; 
                                 border: 1px solid black; 
                                 text-align: left; 
                                 font-size: 12px; /* Adjusted font size */
                                 line-height: 1.2; 
                             }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}
